import { styled } from 'styled-components';
import { FadeOutLoadingBox } from './FadeOutLoadingBox';
export const Row = styled(FadeOutLoadingBox).attrs(() => ({
    px: 4,
})) `
  > :first-child {
    padding-left: ${({ theme }) => `${theme.space[2]}px`};
  }
  > :last-child {
    padding-right: ${({ theme }) => `${theme.space[2]}px`};
  }
`;
//# sourceMappingURL=Row.js.map